(function( app, helpers, $, undefined ) {
  'use strict';

  // Public Method
  helpers.activeMenu = function(top_lebel_id, sub_level_id = null) {
    $("#"+ top_lebel_id).addClass('current')
    if(sub_level_id != null) {
      $("#"+ sub_level_id).addClass('current')
    }
  }

}( window.app ||= {}, 
  window.app.helpers ||= {}, 
  jQuery 
));
